module.exports = __webpack_public_path__ + "cd455783/img/document.e2130c6b.svg";